export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20Thai%20entertainment%20lifestyle%20young%20people%20watching%20short%20videos%20on%20smartphones%20in%20colorful%20neon%20lit%20urban%20Bangkok%20setting%20with%20dramatic%20cinematic%20atmosphere%20warm%20red%20orange%20golden%20tones%20bokeh%20background&width=1440&height=900&seq=hero-bg-001&orientation=landscape"
          alt="hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/50"></div>
      </div>

      {/* Floating decorative elements */}
      <div className="absolute top-32 right-10 md:right-32 w-16 h-16 flex items-center justify-center animate-bounce opacity-80">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-yellow-400 to-orange-400 flex items-center justify-center shadow-lg">
          <i className="ri-coin-line text-white text-2xl"></i>
        </div>
      </div>
      <div className="absolute top-48 right-24 md:right-64 w-10 h-10 flex items-center justify-center animate-pulse opacity-60">
        <div className="w-8 h-8 rounded-full bg-yellow-400 flex items-center justify-center">
          <i className="ri-star-fill text-white text-sm"></i>
        </div>
      </div>
      <div className="absolute bottom-40 right-16 md:right-48 w-12 h-12 flex items-center justify-center animate-bounce opacity-70" style={{ animationDelay: "0.5s" }}>
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-400 to-pink-400 flex items-center justify-center">
          <i className="ri-heart-fill text-white text-base"></i>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-star-fill text-yellow-400 text-sm"></i>
            <span className="text-white text-sm font-medium">แอปดูซีรีส์ยอดนิยมในไทย</span>
          </div>

          {/* Main Title */}
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4">
            ดูซีรีส์สั้น
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
              แล้วรับเงินจริง!
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-white/80 text-lg md:text-xl mb-3 leading-relaxed">
            ดูซีรีส์ · บันเทิง · รับรางวัล
          </p>
          <p className="text-white/60 text-base md:text-lg mb-10">
            เปลี่ยนเวลาว่างให้มีคุณค่า ดูซีรีส์สั้นคุณภาพสูง พร้อมรับรางวัลทุกวัน
          </p>

          {/* Stats Row */}
          <div className="flex flex-wrap gap-6 mb-10">
            {[
              { num: "1M+", label: "ผู้ใช้งาน" },
              { num: "10,000+", label: "ตอนซีรีส์" },
              { num: "฿500+", label: "รับได้ต่อเดือน" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-yellow-400">{stat.num}</div>
                <div className="text-white/60 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#download"
              onClick={(e) => { e.preventDefault(); scrollTo("download"); }}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-red-500 to-orange-400 text-white px-8 py-4 rounded-full text-lg font-bold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap shadow-xl shadow-red-500/40"
            >
              <i className="ri-download-line text-xl"></i>
              ดาวน์โหลดฟรี
            </a>
            <a
              href="https://line.me/ti/p/rwV4hTkrHJ"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-white/15 backdrop-blur-sm border-2 border-white/40 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-smile-2-line text-xl"></i>
              เพิ่ม LINE
            </a>
          </div>

          {/* Register bonus */}
          <div className="mt-6 inline-flex items-center gap-2 bg-yellow-400/20 border border-yellow-400/40 rounded-full px-5 py-2">
            <i className="ri-gift-2-line text-yellow-400 text-lg"></i>
            <span className="text-yellow-300 text-sm font-semibold">สมัครทันที รับสะสมได้ถึง 3,500+ เหรียญ!</span>
          </div>
          {/* Trust line */}
          <p className="mt-4 text-white/50 text-sm flex items-center gap-2">
            <i className="ri-shield-check-line text-green-400"></i>
            ฟรี 100% · สมัครด้วยเบอร์โทร · ถอนผ่าน USDT/USDC
          </p>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H0Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
}
